import './BookADiscoveryCall.css'
function BookADiscoveryCall () {
    return (
        <a href="https://rememberingayurveda.janeapp.com" target="_blank" 
  rel="noopener noreferrer" className="book-a-discovery-call">Book A Free Discovery Call</a>
    )
}

export default BookADiscoveryCall;